/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './codemirror.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/codemirror/codemirror.component';
const styles_CodemirrorComponent:any[] = [i0.styles];
export const RenderType_CodemirrorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CodemirrorComponent,data:{}});
export function View_CodemirrorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_CodemirrorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-codemirror',
      ([] as any[]),(null as any),(null as any),(null as any),View_CodemirrorComponent_0,
      RenderType_CodemirrorComponent)),i1.ɵdid(114688,(null as any),0,i2.CodemirrorComponent,
      [i1.ElementRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CodemirrorComponentNgFactory:i1.ComponentFactory<i2.CodemirrorComponent> = i1.ɵccf('admin-codemirror',
    i2.CodemirrorComponent,View_CodemirrorComponent_Host_0,{value:'value',lineNumbers:'lineNumbers'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NvZGVtaXJyb3IvY29kZW1pcnJvci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvY29kZW1pcnJvci9jb2RlbWlycm9yLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2NvZGVtaXJyb3IvY29kZW1pcnJvci5jb21wb25lbnQudHMuQ29kZW1pcnJvckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxhZG1pbi1jb2RlbWlycm9yPjwvYWRtaW4tY29kZW1pcnJvcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtvQ0FBQSxVQUFBO01BQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/codemirror/codemirror.component.ngfactory.ts